export const tableSortingOrder = {
    ASC: 'asc',
    DESC: 'desc'
}

export const defaultRowsPerPage = 25;